export default __webpack_public_path__ + "d91cd4c46e63abe1c42d832951bdf3e4.png";